import { render, staticRenderFns } from "./ProductEditLabels.vue?vue&type=template&id=05d7c2ae"
import script from "./ProductEditLabels.vue?vue&type=script&lang=ts"
export * from "./ProductEditLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports